<aside class="side-nav" [ngClass]="profileClass" [attr.data-profile]="profile">
  <!-- Logo Header -->
  <div class="side-nav-header">
    <svg
      class="side-nav-logo"
      width="228"
      height="30"
      viewBox="0 0 228 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Huro"
    >
      <g clip-path="url(#clip0_2713_9779)">
        <path
          d="M30.8035 10.4449C32.4547 12.0133 33.2635 14.3493 33.2635 17.4527V18.2202H28.2088V18.0868C28.2088 16.218 27.7707 14.8165 26.8608 13.8487C25.9847 12.9144 24.7042 12.4138 23.053 12.4138C21.1996 12.4138 19.7168 12.9811 18.6385 14.0823C17.5602 15.1835 17.021 16.7853 17.021 18.8543V29.6663H12V0H17.0547V10.812C17.8972 9.94438 18.9081 9.24361 20.1549 8.77642C21.3681 8.30923 22.7497 8.07564 24.2661 8.07564C26.9956 8.07564 29.186 8.87653 30.8035 10.4449Z"
          fill="white"
        />
        <path
          d="M49.2703 8.34277V29.7332H44.4514V26.9968C43.6427 27.9646 42.6317 28.6987 41.4186 29.2327C40.2055 29.7666 38.8913 30.0002 37.5096 30.0002C34.6116 30.0002 32.3538 29.1993 30.7026 27.6309C29.0514 26.0625 28.209 23.6932 28.209 20.5563V19.622H33.2637V19.8556C33.2637 21.791 33.7018 23.226 34.5779 24.1603C35.4541 25.0947 36.7009 25.5953 38.3184 25.5953C40.1381 25.5953 41.5534 25.028 42.6317 23.9268C43.7101 22.8255 44.2156 21.2238 44.2156 19.1548V8.34277H49.2703Z"
          fill="white"
        />
        <path
          d="M64.9395 8.07568V12.8477C64.5014 12.7809 64.1307 12.7142 63.76 12.7142C61.8056 12.7142 60.2554 13.2815 59.1434 14.4161C58.0314 15.5507 57.4922 17.1858 57.4922 19.3215V29.6997H52.4375V8.34265H57.2563V11.4795C58.7053 9.24365 61.2664 8.10905 64.9395 8.10905V8.07568Z"
          fill="white"
        />
        <path
          d="M71.5782 28.5983C69.8259 27.6639 68.4443 26.3625 67.4671 24.694C66.4898 23.0255 65.9844 21.1233 65.9844 19.021C65.9844 16.9187 66.4898 15.0166 67.4671 13.3814C68.4443 11.7129 69.8259 10.4448 71.5782 9.51044C73.3305 8.57607 75.285 8.10889 77.4754 8.10889C79.6658 8.10889 81.654 8.57607 83.4063 9.51044C85.1586 10.4448 86.5402 11.7463 87.5174 13.3814C88.4947 15.0499 89.0001 16.9187 89.0001 19.021C89.0001 21.1233 88.4947 23.0255 87.5174 24.694C86.5402 26.3625 85.1586 27.6639 83.4063 28.5983C81.654 29.5327 79.6658 29.9999 77.4754 29.9999C75.285 29.9999 73.3305 29.5327 71.5782 28.5983ZM82.092 23.8597C83.3052 22.625 83.9117 21.0232 83.9117 19.021C83.9117 17.0188 83.3052 15.417 82.092 14.1823C80.8789 12.9476 79.3288 12.3469 77.4754 12.3469C75.622 12.3469 74.0719 12.9476 72.8925 14.1823C71.6793 15.417 71.1065 17.0188 71.1065 19.021C71.1065 21.0232 71.713 22.625 72.8925 23.8597C74.1056 25.0944 75.622 25.6951 77.4754 25.6951C79.3288 25.6951 80.8789 25.0944 82.092 23.8597Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2713_9779">
          <rect width="77" height="30" fill="white" transform="translate(12)" />
        </clipPath>
      </defs>
    </svg>
  </div>

  <!-- Optional content projected between the logo and navigation (e.g. facility selector) -->
  <ng-content select="[slot=facility-selector]"></ng-content>

  <!-- Navigation Content -->
  <nav class="side-nav-content">
    <!-- Navigation Groups -->
    <div *ngFor="let group of filteredViews" class="side-nav-group">
      <!-- Group Label -->
      <umss-menu-group-label *ngIf="group.label" [text]="group.label">
      </umss-menu-group-label>

      <!-- Group Items -->
      <div class="side-nav-items">
        <div
          *ngFor="let item of group.items"
          class="side-nav-item"
          [class.selected]="item.selected"
          [class.disabled]="item.disabled"
        >
          <ng-container *ngIf="!item.hidden">
            <ng-container *ngIf="item.value === 'user'; else menuItem">
              <!-- User Profile Section -->
              <button
                *ngIf="user"
                class="side-nav-user"
                (click)="onUserProfileClick()"
              >
                <button type="button" class="side-nav-user-button">
                  <umss-avatar
                    [name]="user.name"
                    [src]="user.avatarSrc"
                    [initials]="user.initials"
                    size="Regular"
                    shape="Circle"
                    class="side-nav-user-avatar"
                  >
                  </umss-avatar>

                  <div class="side-nav-user-info">
                    <span class="side-nav-user-name">{{ user.name }}</span>
                    <span class="side-nav-user-role">{{ user.role }}</span>
                  </div>
                </button>
              </button>
            </ng-container>
            <ng-template #menuItem>
              <button
                type="button"
                class="side-nav-item-button"
                [disabled]="item.disabled"
                (click)="onItemClick(item)"
              >
                <!-- Icon -->
                <umss-icon
                  *ngIf="item.iconName"
                  [name]="item.iconName"
                  size="16px"
                  class="side-nav-item-icon"
                >
                </umss-icon>

                <!-- Label -->
                <span class="side-nav-item-label">{{ item.label }}</span>

                <!-- Badge -->
                <umss-badge
                  *ngIf="item.showBadge && item.badge"
                  [label]="item.badge.toString()"
                  size="small"
                  variant="primary"
                  class="side-nav-item-badge"
                >
                </umss-badge>
              </button>
            </ng-template>
          </ng-container>
        </div>
      </div>
    </div>
  </nav>
</aside>
